import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const PdfViewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  canvas {
    border-radius: 5px;
  }

  .react-pdf__Page__textContent {
    display: none !important;
  }
`;

export const PdfViewControlPainel = styled.div`
  font-size: 16px;
  color: black;
  background-color: white;
  border-radius: 5px;
  width: 850px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 16px;
`;

export const PdfViewControlPainelLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg.clickable {
    cursor: pointer !important;
    color: ${colors.bgPrimary};
  }

  svg.disabled {
    cursor: not-allowed !important;
    color: ${colors.textSecondary};
  }
`;

export const PdfViewControlPainelRight = styled.div``;

export const PdfViewControlPainelZoom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    cursor: pointer;
    color: ${colors.bgPrimary}
  }

  svg:first-child {
    margin-right: 4px;
  }

  svg:last-child {
    margin-left: 4px;
  }
`;

export const PdfViewControlPainelDownload = styled.div``;
